module.exports = __webpack_public_path__ + "static/media/garage-car.10ba0093.svg";